/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Icon from 'assets/images/icon-doc-time.svg';

import { Container } from './styles';

interface ModalAuthenticationDocumentProps {
  authenticationSuccess: boolean;
  showModalAuthenticationStatus: boolean;
  setshowModalAuthenticationStatus: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalAuthenticationDocument = (props: ModalAuthenticationDocumentProps) => {
  const { authenticationSuccess, showModalAuthenticationStatus, setshowModalAuthenticationStatus } =
    props;

  return (
    <Modal show={showModalAuthenticationStatus} className="d-flex align-items-center">
      <Container>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="mx-5 text-center">
          {authenticationSuccess && (
            <>
              <div className="mt-5">
                <img src={Icon} width="50px" />
              </div>
              <p className="mb-5">
                <span className="font-weight-bold">Autenticação de documento solicitada.</span>
                <br /> Isso pode demorar alguns dias. Você será notificado assim que a autenticação
                estiver disponível.
              </p>
            </>
          )}
          {!authenticationSuccess && (
            <>
              <div className="text-danger mt-5">
                <span className="material-icons display-3">error_outline</span>
              </div>
              <p className="mb-5">
                <span className="font-weight-bold">Erro ao autenticar o documento.</span>
                <br /> Tente novamente
              </p>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={() => setshowModalAuthenticationStatus(false)}
          >
            Fechar
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalAuthenticationDocument;
